import { PanelLeftClose, PanelRightClose } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/common/components/ui/button';

interface PageNavigatorToggleProps {
  isNavigatorVisible: boolean;
  onToggle: () => void;
  className?: string;
}

export const PageNavigatorToggle = ({
  isNavigatorVisible,
  onToggle,
  className,
}: PageNavigatorToggleProps) => {
  const { t } = useTranslation();

  return (
    <Button
      onClick={onToggle}
      variant="outline"
      size="icon"
      className={className}
      aria-label={
        isNavigatorVisible
          ? t('navigation.hidePageNavigator')
          : t('navigation.showPageNavigator')
      }
    >
      {isNavigatorVisible ? <PanelLeftClose /> : <PanelRightClose />}
    </Button>
  );
};
